module.exports = __webpack_public_path__ + "static/img/IMG_20160307_131856-PANO.6f5722d1.jpg";